/* eslint no-console:0 */

import Rails from "@rails/ujs"
import "@hotwired/turbo-rails"

Turbo.session.drive = false

// import * as ActiveStorage from "@rails/activestorage"
import "../src/channels"
import "../controllers"

Rails.start()
// ActiveStorage.start()

// Library Code
import "../src/jquery_wrapper"
import "popper.js/dist/popper.min.js"              // Bootstrap dep
import "bootstrap/dist/js/bootstrap"               // Bootstrap
import "bootstrap-datepicker"                      // Bootstrap datepicker: for dates
import "blueimp-file-upload"                       // Jquery-file-upload: direct-to-cloud-uploads
import "bootstrap-select/dist/js/bootstrap-select" // Bootstrap select: multi-select for statuses

import.meta.glob("../images", { eager: true })

// App Proper
import "../src/site"
import "../src/site/styles/site.scss"
